import { render, staticRenderFns } from "./PdpPopupV1.vue?vue&type=template&id=02e9d7c4&scoped=true&"
import script from "./PdpPopupV1.vue?vue&type=script&lang=js&"
export * from "./PdpPopupV1.vue?vue&type=script&lang=js&"
import style0 from "./PdpPopupV1.vue?vue&type=style&index=0&id=02e9d7c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e9d7c4",
  null
  
)

export default component.exports